let LangEn = {
  ProductBand: 'Defender File Flow System',
  haTakeover: 'Backup node has taken over. Please check and repair the primary host as soon as possible',
  dashboard: {
    totalInvokeNum: 'Total Page Views (PV)',
    weekRate: 'Week-over-week Ratio',
    dayRate: 'Day-over-day Ratio',
    yesterdayInvoke: 'Yesterday Page Views (PV)',
    totalUV: 'Number of Logged-in Users',
    yesterdayUV: 'Yesterday Logged-in Users',
    totalMatterNum: 'Total Files',
    yesterdayMatterNum: 'Yesterday Files',
    totalFileSize: 'Total File Size',
    yesterdayMatterSize: 'Yesterday File Size',
    recentDayInvokeUV: 'Recent {} Days Page Views/Login Count',
    downloadMatterTop10: 'Top 10 File Downloads',
    activeIpTop10: 'Top 10 Active IPs',
    loading: 'Loading...',
    date: 'Date',
    num: 'Quantity',
    yesterday: 'Yesterday',
    warnHint: 'You can manually refresh if needed',
    reRun: 'Refresh',
    availableDiskSpace: 'Available Disk Space',
    cpuUsage: 'CPU Usage',
    storageUsage: 'Storage Usage',
    totalMemory: 'Total Memory',
    systemStatus: 'System Status Monitoring',
    memory: 'Memory Usage',
    storage: 'Disk Usage',
    usageStats: 'Access Statistics',
    storageInfo: 'Storage Information'
  },
  install: {
    selectDeploy: 'Deployment Method',
    fastDeploy: 'Quick Deployment',
    stepDeploy: 'Step-by-step Deployment',
    configMysql: 'Configure Database',
    dbType: 'Database Type',
    port: 'Port',
    schema: 'Database Name',
    username: 'Username',
    password: 'Password',
    charset: 'Character Set',
    mysqlConnectionPass: 'MySQL Connection Test Passed',
    testMysqlConnection: 'Test MySQL Connection',
    notice: 'Notice',
    sqliteNotice1: 'SQLite is a lightweight file database that can be used without installation',
    mysqlNotice1: 'If the database is installed on the same server as this system, Host can be filled as 127.0.0.1.',
    mysqlNotice2: 'The database account must have permission to create tables; otherwise, the "Create Tables" operation in step two will fail',
    validateMysqlFirst: 'Please validate the database connection first',
    fastDeplyNotice: 'Quick deployment currently only supports SQLite database',
    preStep: 'Previous',
    nextStep: 'Next',
    createTable: 'Create Tables',
    installed: 'Installed',
    installedButMissing: 'Installed, Missing Fields',
    toBeInstalled: 'To be Installed',
    allFields: 'All Fields',
    missingFields: 'Missing Fields',
    tableNotice: 'After clicking "One-click Create Tables", the following logic will be executed:',
    tableNotice1: 'If a table does not exist, it will be created directly.',
    tableNotice2: 'If a table exists and has all fields, no operation will be performed on that table.',
    tableNotice3: 'If a table exists but some fields are missing, the missing fields will be added to that table.',
    tableNotice4: 'If there are extra fields in the table (fields that are not required), they will not be deleted but will remain as is.',
    oneKeyCreate: 'One-click Create Tables',
    createFinish: 'Table Creation Completed',
    createTableSuccess: 'Table creation successful',
    crateTableFirst: "Please click 'One-click Create Tables' first",
    setAdministrator: 'Set Administrator',
    detectAdministrator: 'The following administrators have been detected in the system:',
    useOrCreateAdministrator: 'You can validate one of the existing administrators or create a new administrator account',
    validateAdministrator: 'Validate Administrator Account',
    createAdministrator: 'Create Administrator Account',
    administratorUsername: 'Administrator Username',
    administratorPassword: 'Administrator Password',
    administratorRePassword: 'Confirm Password',
    usernameRule: 'Since the username will be used as the file upload directory, only letters, numbers, and "_" are allowed.',
    congratulationInstall: 'Congratulations, installation successful!',
    configAdminFirst: 'Please configure administrator information first!',
    createAdminSuccess: 'Administrator created successfully (default: admin/HWZ@1234)!',
    validateAdminSuccess: 'Administrator validation successful!',
    pressToHome: 'Click the button below to complete the installation and enter the homepage.',
    enterHome: 'Complete and Enter Homepage',
    finish: 'Finish',
  },
  log: {
    title: 'Operation Log',
    operation: 'Operation Type',
    target: 'Operation Target',
    user: 'Operator',
    space: 'Belonging Space',
    detail: 'Operation Details',
    ip: 'IP Address',
    createTime: 'Operation Time',
    searchPlaceholder: 'Search logs...',
    allOperations: 'All Operations',
    objectName: 'Target Name',
    upload: 'Upload',
    delete: 'Delete',
    softDelete: 'Soft Delete',
    recovery: 'Restore',
    download: 'Download',
    rename: 'Rename',
    move: 'Move',
    copy: 'Copy',
    createDirectory: 'Create Directory',
    upload_blocked: 'Upload Blocked',
    download_blocked: 'Download Blocked',
    change_privacy: 'Change File Privacy',
    outsend_apply: 'External Send Application',
    approval: 'Approval',
    forward: 'Forward',
    uploadskip:'Upload Skip',
    syncskip:'Synchronization Skip',
    // File synchronization related operations
    sync_success: 'Synchronization Successful',
    sync_failed: 'Synchronization Failed',
    sync_received: 'Synchronization Received',
    outsend_sync_success: 'External Send Synchronization Successful',
    outsend_sync_failed: 'External Send Synchronization Failed',
    export: 'Export', 
    clean: 'Clean', 
    cleanConfirm: 'Are you sure you want to clean system logs older than {keepDays} days?', 
    cleanSuccess: 'Cleaned successfully', 
    cleanFailed: 'Failed to clean', 
    // Sharing related operation types
    set_public_readonly: 'Set Public Read-only Share',
    set_public_full: 'Set Public Full Share',
    set_private_readonly: 'Set Private Read-only Share',
    set_private_full: 'Set Private Full Share',
    remove_share: 'Cancel Share',
    preview_share_file: 'Preview Shared File',

    // Share viewing related operation types
    view_public_share_detail: 'View Public Share Details',
    view_private_share_owner: 'View Private Share (Creator)',
    view_private_share_target: 'View Private Share (Recipient)',
    view_my_shares: 'View My Shares',
    view_shares_shared_to_me: 'View Content Shared to Me',
    browse_share: 'Browse Share Content',
    download_share_zip: 'Download Share Zip',
    browse_share_files: 'Browse Share File List',
    download_share_file: 'Download Shared File',
    matter: 'File',
    directory: 'Directory',
    
    // 新增的本地日志和移动盘日志相关翻译
    localLogs: 'Local Logs',
    removableLogs: 'Removable Disk Logs',
    removableDevice: 'Removable Storage Device',
    usbDevice: 'USB Device',
    hardDisk: 'Hard Disk',
    solidStateDisk: 'Solid State Disk',
    sdCard: 'SD Card',
    mobileDevice: 'Mobile Device',
    unknownDevice: 'Unknown Device',
    deviceInfo: 'Device Information',
  },

  layout: {
    allFiles: 'Personal Space', 
    myShare: 'My Shares',
    bin: 'Recycle Bin',
    setting: 'System Settings',
    managementPage: 'Management Backend',
    FilesCirculation: 'File Circulation',
    PCSecPage: 'Endpoint Security Management',
    dashboard: 'System Overview',
    users: 'User Management',
    logout: 'Logout',
    about: 'About',
    install: 'Install System',
    dragMouseUp: 'You can release now~',
    space: 'Shared Groups',
    fileslog: 'File Logs',
    systemlog: 'System Logs',
    removableLogs: 'Removable Storage Logs',
    onlinePC: 'Host List',
    departments: 'Department Management',
    removableFileBrowser: 'Removable Disk',
    onlineUsers: 'Online Users',
  },
  member: {
    // New search related
    searchUsername: 'Search Username',
    selectRole: 'Select Role',
    filterRole: 'Filter by Role',
    showDeptMembersOnly: 'Show Department Members Only',
    roleDistribution: 'Role Distribution',
    memberStatistics: 'Member Statistics',
    deleteDeptMemberConfirm: 'Confirm to delete department member?',
    deleteDeptMemberWarning: 'After deleting department member, it will not be automatically synced to this space',
    
    willNotAutoAddAgain: 'Will not be automatically added again after deletion',
    canManuallyReadd: 'If you need to add again, please do it manually',
    deptSyncWillSkip: 'Department synchronization will skip deleted members',
    syncWillNotReadd: 'Synchronization will not re-add deleted members',
    // Table related
    memberAvatar: 'Avatar',
    memberUsername: 'Username',
    memberDepartment: 'Department',
    memberRole: 'Member Role',
    memberSource: 'Source',
    memberCreateTime: 'Creation Time',
    memberOperation: 'Operation',
    memberCurrentUser: 'Current User',
    memberFromDepartment: 'From Department',
    memberTooltipManual: 'Manual Addition',
    memberEdit: 'Edit',
    memberUnbind: 'Unbind',
    
    // Statistics related
    totalMembers: 'Total Members',
    deptMembers: 'Department Members',
    manualMembers: 'Manual Addition',

    // Fixed text as per Chinese version
    memberFromDepartmentWithName: 'From Department',
  },
  department: {
    // Import/Export related
    import: 'Import Department',
    export: 'Export Department',
    exportExcel: 'Export as Excel',
    exportJSON: 'Export as JSON',
    exportSuccess: 'Successfully exported {0} department records',
    exportEmpty: 'No department data available for export',
    importTitle: 'Import Department Configuration',
    importTips: 'Please upload CSV or JSON format department data file, supports updating existing department data',
    uploadFile: 'Upload File',
    selectFile: 'Select File',
    supportedFormats: 'Supported formats: CSV, JSON',
    importOptions: 'Import Options',
    updateExisting: 'Update existing departments',
    keepRelations: 'Maintain department relationships',
    skipErrors: 'Skip errors and continue import',
    importProgress: 'Import Progress',
    startImport: 'Start Import',
    importing: 'Importing...',
    fileUploadSuccess: 'File uploaded successfully',
    fileReadError: 'File read failed',
    csvFormatError: 'CSV format error',
    jsonFormatError: 'JSON format error',
    unsupportedFormat: 'Unsupported file format',
    emptyData: 'Import data is empty',
    missingRequiredField: 'Row {0} missing required field: {1}',
    invalidType: 'Row {0} invalid department type: {1}',
    invalidStatus: 'Row {0} invalid status value: {1}',
    duplicateCode: 'Department short name duplicate: {0}',
    dataValid: 'Data validation passed, total {0} records',
    fileReady: 'File ready, total {0} records',
    startingImport: 'Starting department data import...',
    importingDept: 'Importing department: {0} ({1}/{2})',
    importComplete: 'Import completed! Success: {0}, Failed: {1}',
    importSuccess: 'Successfully imported {0} department records',
    importFailed: 'Department import failed',
    importWithErrors: 'Import completed, Success: {0}, Failed: {1}',
    importError: 'Department {0} import failed: {1}',
    noImportData: 'No data to import',
    templateFormat: 'Template Format Description',
    fieldName: 'Field Name',
    fieldKey: 'Field Key',
    required: 'Required',
    example: 'Example',
    description: 'Description',
    parentCode: 'Parent Department Code',
    parentCodeDesc: 'Fill in the short name of parent department to establish hierarchical relationships',
    orderIndex: 'Sort Order',
    // Department-related
parentNodeHint: 'Tip: You can select a parent node (e.g., Headquarters, Technology Department); the system will automatically include all users from its sub-departments.',
parentNode: 'Parent Node',
selectAll: 'Select All',
clearAll: 'Clear All',
expandAllDepts: 'Expand All Departments',
expandAllDeptsDesc: 'Expand all department nodes by default for easier selection',
parentNodeImportantHint: 'Important: Selecting a parent node will also select all of its child nodes',
selectDepartmentsCount: '{0} department(s) selected',
totalAffectedDepts: 'A total of {0} department(s) will be affected',
deptIdFormat: 'Department {0}',

// Batch operation-related
confirmBatchUpdateRole: 'Are you sure you want to update the role of all members in the selected departments to "{0}"?',
confirmRemoveDept: 'Are you sure you want to remove the binding for this department?',
syncComplete: 'Sync completed',
batchAddDeptSuccess: 'Batch addition successful',
partialSuccess: 'Partially successful',
deptAddSuccessLog: 'Department added successfully',
deptAddFailLog: 'Failed to add department',
andMoreDepts: '...and other departments',
boundDeptCount: '{0} department(s) bound',
    orderIndexDesc: 'Lower numbers appear first',
    downloadTemplate: 'Download Template',
    templateDownloadSuccess: 'Template downloaded successfully',
    readyToImport: 'Ready to import {0} records',
    circularDependency: 'Circular dependency detected, please check department hierarchy',
    // Common
    id: 'Department ID',
    deptNo: 'Department Number',
    shortName: 'Department Short Name',
    fullName: 'Department Full Name',
    type: 'Department Type',
 
    orderNo: 'Order Number',
    parentDept: 'Parent Department',
    parentName: 'Parent Department Name',
    topLevel: 'Top Level Department',
    selectParentDept: 'Select Parent Department',
    selectType: 'Select Department Type',
    selectStatus: 'Select Status',
    remark: 'Remark',
    noParentDept: 'No available parent department',
    
    // User information
    createUser: 'Created By',
    updateUser: 'Updated By',
    
    // Form validation
    idRequired: 'Department ID cannot be empty',
    shortNameRequired: 'Please enter department short name',
    fullNameRequired: 'Please enter department full name',
    typeRequired: 'Please select department type',
    orderIndexRequired: 'Please enter sort index',
    orderIndexMin: 'Sort index cannot be negative',
    shortNameMaxLength: 'Department short name maximum 50 characters',
    fullNameMaxLength: 'Department full name maximum 100 characters',
    orderIndexRange: 'Sort index must be between 0-9999',
    
    // Placeholders
    deptNoPlaceholder: 'Please enter department number',
    shortNamePlaceholder: 'Please enter department short name',
    fullNamePlaceholder: 'Please enter department full name',
    remarkPlaceholder: 'Please enter remark',
    
    // Operations
    createDept: 'Create Department',
    editDept: 'Edit Department',
    viewDept: 'View Department',
    deleteDept: 'Delete Department',
    deleteHint: 'Confirm delete department?',
    deleteConfirm: 'Cannot be recovered after deletion, please operate carefully',
    batchDelete: 'Batch Delete',
    batchDeleteConfirm: 'Confirm delete selected departments?',
    selectDelete: 'Please select departments to delete first',
    batchAddConfirm: 'Confirm add selected departments?',

    // Types
    company: 'Organization',
    department: 'Department',
    team: 'Team',
    
    // Status
    enabled: 'Enabled',
    disabled: 'Disabled',
    
    // Search
    search: 'Department Search',
    searchHint: 'Search by department name, short name',
    deptNoSearch: 'Department Number',
    nameSearch: 'Department Name',
    shortNameSearch: 'Department Short Name',
    typeSearch: 'Department Type',
    statusSearch: 'Status',
    
    // Table columns
    operation: 'Operation',
    status: 'Status',
    createTime: 'Create Time',
    updateTime: 'Update Time',

    // Tree operations
    expandAll: 'Expand All',
    collapseAll: 'Collapse All',
    
    // Success messages
    createSuccess: 'Department created successfully',
    updateSuccess: 'Department updated successfully',
    deleteSuccess: 'Department deleted successfully',
    
    // Error messages
    nameExists: 'Department name already exists',
    shortNameExists: 'Department short name already exists',
    parentDeptNotExists: 'Parent department does not exist',
    deptHasChildren: 'Department has sub-departments, cannot delete',
    deptHasUsers: 'Department has users, cannot delete',
    circularReference: 'Cannot set department as its own sub-department',
    
    // Level
    level: 'Level',
    
    // Statistics
    totalCount: 'Total Departments',
    rootCount: 'Root Departments',
    companyCount: 'Organizations',
    deptCount: 'Departments',
    teamCount: 'Teams',
    statistics: 'Department Statistics',
    
    // Additional content
    idFormat: 'Department',
    boundDepartments: 'Bound Departments',
    syncMembers: 'Sync Members',
    batchSetRole: 'Batch Set Role',
    noBoundDepartments: 'No departments bound',
    selectedDepartmentsCount: 'Selected Departments',
    batchAddByDept: 'Batch Add by Department',
    batchAddDeptHint: 'Select departments to add, system will automatically add all users under selected departments to current space',
    selectDepts: 'Select Departments (Multiple)',
    manualAdd: 'Manual Add',
    manual: 'Manual',
    batchAdd: 'Batch Add',
    addByDept: 'Add by Department',

    addDeptMembers: 'Add all users under selected departments',
    skipExistingMembers: 'Skip existing members',
    setDefaultRole: 'Set default role as "Member"',
    autoProcess: 'System will automatically',
    partialAddSuccess: 'Partial add success',
    noUsersInDept: 'No users in selected departments',
    noDeptBound: 'No departments bound to current space',
    syncDeptMembers: 'Sync Department Members',
    confirmSyncDeptMembers: 'Confirm re-sync members of bound departments?',
    willProcess: 'System will',
    addNewDeptUsers: 'Re-add newly joined users in departments',
    removeLeftUsers: 'Remove departed users',
    keepOriginalSettings: 'Keep original member settings',
    startSync: 'Start Sync',

    memberStatusUpToDate: 'Member status is up to date, no sync needed',
    removeDeptBinding: 'Remove Department Binding',

    afterRemove: 'After removal',
    noAutoSync: 'No longer auto-sync members of this department',
    existingMembersNotDeleted: 'Existing members will not be deleted',
    canRebindLater: 'Can re-bind this department anytime',
    deptBindingRemoved: 'Department binding removed',
    batchUpdateDeptRole: 'Batch Update Department Member Roles',
    confirmUpdateRole: 'Confirm update roles for all members in selected departments?',
    roleUpdateWarning: 'This will override existing role settings of department members, operate carefully!',
    partialUpdateSuccess: 'Partial update success',
    bindMemberConfirm: 'Confirm add selected departments?',
    batchUpdateTitle: 'Batch Update Department Member Roles',
    batchUpdateSelectDepartment: 'Select departments to update roles:',
    batchUpdateSelectRole: 'Select role to set:',
    batchUpdateSelectedDepartments: 'Selected Departments',
    batchUpdateSelectedDepartmentsDesc: 'All member roles under these departments will be updated',
    batchUpdateNote: 'Note',
    batchUpdateNoteDesc: 'This will override all existing role settings of selected department members',
    batchUpdateOkText: 'Batch Update',
    
    // Search related
    filterByDept: 'Filter by Department',
    selectDept: 'Select Department',

    // Additional fields
    selectFirst: 'Please select departments to add first',
    noDeptToAdd: 'No departments to add',
    syncAffectedDepts: 'Will affect following departments:',
    syncWarning: 'This will sync members of all bound departments, may affect many users',
    syncDeptMembersFail: 'Sync department members failed:',
    removeDeptBindingFail: 'Remove department binding failed:',
    batchUpdateRoleFail: 'Batch update role failed:',

    addMode: 'Add Mode',
    includeSubDepts: 'Include Sub-departments',
    excludeSubDepts: 'Selected Departments Only',
    includeSubDeptsDesc: 'Add selected departments and all their sub-departments',
    excludeSubDeptsDesc: 'Add only selected departments, exclude sub-departments',
    subDeptsHint: 'Sub-department Processing',
    subDeptsHintDesc: 'System automatically includes all sub-departments of selected departments, no manual selection needed',
    batchAddProcessNote: 'Processing Instructions',
    eachDeptIndependent: 'Each department processed independently',
    
    // New additions

    totalCreated: 'Total spaces created',
    willBatchCreateForDepts: 'Will batch create spaces for selected departments',
},
  // Success Messages
  operations: {
    success: 'Operation Successful',
    uploadSuccess: 'Upload Successful',
    downloadSuccess: 'Download Successful',
    deleteSuccess: 'Delete Successful',
    renameSuccess: 'Rename Successful',
    moveSuccess: 'Move Successful',
    copySuccess: 'Copy Successful',
    shareSuccess: 'Share Successful',
    saveSuccess: 'Save Successful',
    createSuccess: 'Create Successful',
    updateSuccess: 'Update Successful',
    // New batch operation related
    batchAddSuccess: 'Batch Addition Successful',
    batchUpdateSuccess: 'Batch Update Successful',
    syncSuccess: 'Synchronization Successful',
  },
  matter: {
    print: "Print",
    downloading: "Downloading...",
    printing: "Printing...",
    downloadStarted: "File download has started",
    downloadFailed: "File download failed",
    printFailed: "File print failed",
    printNotSupported: "This file type does not support direct printing",
    pdfPrintHint: "PDF file has been opened in a new window, please use the browser's print function (Ctrl+P)",
    cadPrintHint: "CAD drawing printing requires specialized CAD software; it is recommended to download and use professional software",
    mindMapPrintHint: "Mind map printing is recommended to download and use professional mind mapping software",
    printPopupBlocked: "Print window blocked; please allow pop-up windows",
    noDownloadPermission: "You do not have permission to download this file",
    noPrintPermission: "You do not have permission to print this file",

    file: 'File',
    directoryDragNotSupported: 'Browser does not support directory drag and drop upload',
    uploadError: 'Upload Failed',
    partialUploadSuccess: 'Files uploaded successfully',
    directory: 'Folder',
    rename: 'Rename',
    download: 'Download',
    delete: 'Delete',
    hardDelete: 'Permanently Delete',
    recovery: 'Restore',
    more: 'More',
    share: 'Share',
    close: 'Close',
    size: 'Size',
    preview: 'Preview',
    move: 'Move',
    moveTo: 'Move to',
    upload: 'Upload',
    create: 'Create New',
    createTime: 'Creation Time',
    updateTime: 'Modification Time',
    deleteTime: 'Deletion Time',
    uploadUserNickname: 'Uploader',
    root: 'Root Directory',
    fillInPicLink: 'Please fill in the image link',
    rePick: 'Reselect',
    unknown: "Unknown Status",
    chooseImage: 'Select Image',
    uploadMode: 'Upload Mode',
    approvalMode: 'Approval Mode',
    normalMode: 'Normal Mode',
    toapprovalMode: '<- Click to switch to approval mode',
    tonormalMode: '<- Click to switch to normal approval mode',
    exportAudit: 'External Send Application',
    selectFileFirst: 'Please select file first',
    fillMode: 'Fill Mode',
    sizeExceedLimit: 'File size exceeds limit',
    dropNotDirectory: 'Cannot drag and drop folders for upload',
    setPublic: 'Set as public file',
    setPrivate: 'Set as private file',
    copyLink: 'Copy download link',
    enterName: 'Please enter name',
    publicFileEveryoneCanVisit: 'Public file, anyone can access',
    fileDetail: 'File Details',
    expire: 'Validity Period',
    copyLinkAndCode: 'Copy link + extraction code',
    uploaded: 'Uploaded',
    uploadDir: 'Upload Folder',
    uploadDirTooltip: 'Upload entire folder and its subfolder structure',
    uploadInfo: 'Upload Information',
    uploadErrorInfo: 'Some files failed to upload; you can export a CSV file to view details',
    exportCSV: 'Export upload error details',
    speed: 'Speed',
    fileInfo: 'File Basic Information',
    fileName: 'File Name',
    path: 'Path',
    copyPath: 'Copy Path',
    publicOrPrivate: 'File Public/Private Status',
    privateInfo: 'Private file, only self or authorized users can download',
    publicInfo: 'Public file, anyone can download via link',
    downloadTimes: 'Download Count',
    operations: 'Operations',
    approval: 'Approval',
    noneedApproval: 'No approval needed',
    waitApproval: 'Pending approval',
    approvalPass: 'Approval Passed',
    approvalReject: 'Approval Rejected',
    oneTimeLink: 'One-time link',
    oneTimeLinkInfo: 'The link becomes invalid immediately after download; you can share this link with friends, click to copy',
    imageCache: 'Image Cache',
    searchFile: 'Search file',
    noContentYet: 'No content in this directory yet',
    allFiles: 'All Files',
    newDirectory: 'New Folder',
    notChoose: 'No file selected',
    exceed1000: 'Maximum of 1000 files can be selected simultaneously',
    noImageCache: 'No image cache data available',
    recycleBin: 'Recycle Bin',
    deleted: 'Deleted',
    unCompatibleBrowser: 'Current browser not supported; please switch browsers to try',
    canIUse: 'Check if current browser supports; click to jump',
    intoRecycleBin: 'Move to recycle bin',
    finishingTip: 'Background file processing in progress, please wait...',
    scanning: 'Scanning directory...',
    preparing: 'Scanning files...',
    creatingDirs: 'Creating directories...',
    uploading: 'Uploading',
    uploadedWithErrors: 'Upload complete, {0} files failed',
    tooManyFilesWarn: '{0} files found. Large directories may freeze the browser — use drag-and-drop or compress to ZIP.',
    crawl: 'Crawl File',
    crawlLink: 'Link',
    crawlLinkTip: 'Please enter link',
    crawlFilename: 'File Name',
    crawlFilenameTip: 'Please enter file name',
    crawlBackground: 'Background crawl',
    crawlSuccessTip: 'Crawl successful',
    crawlDescription: 'Crawling a file means the backend will directly download from the specified resource link to the current directory of the system',
    dragAlternative: 'Please use the "Upload Folder" button in the upper right corner',
    approvalTitle: 'File Operation Approval',
    uploadApprovalStatus: 'File Upload Approval',
    outsendApprovalStatus: 'File External Send Approval',
    outsendPending: 'Not Applied',
    type: 'Target Type',
    operator: 'Operator',
    approvalStatus: 'Approval Status',
    approvalRemark: 'Remark',
    approvalRemarkPlaceholder: 'Fill in remark',
    reasonPlaceholder: 'Fill in reason',
    reason: 'Reason',
    opsuccess: 'Operation successful',
    fullTextSearch: "Full-text Search",
    fullTextSearchChangeHint: 'Search mode has been changed; please click the search button to search again',

    forwardToOtherSpace: 'Forward to Other Space',
    forwardFiles: 'Forward Files',
    listView: 'List',
    gridView: 'Thumbnail',
    forward: 'Forward to Personal Space',
    forwardConfirmTitle: 'Confirm Forward',
    forwardConfirmContent: 'Are you sure you want to forward the selected files/folders to your personal space?',
    forwarding: 'Forwarding...',
    forwardSuccess: 'Forward Successful',
    forwardProgressTitle: 'Forwarding Files',
    forwardProgressContent: 'Copying file {0} / {1}',
    forwardProgressCurrent: 'Current file: {0}',
    forwardProgressBytes: 'Copied {0} / {1}',
    forwardPartialFiles: 'Forward complete: {0} succeeded, {1} failed',

    forwardFailed: 'Forward Failed',
    forwardNoFilesSelected: 'Please select files or folders to forward first',

    forwardToSpace: 'Forward to Space',
    forwardToSpaceHint: 'Forward selected files from your personal space to the target user\'s group space',
    selectTargetUsersForSpace: 'Select Target Users (and their spaces)',
    selectUserPlaceholderForSpace: 'Please search and select target users',

    selectedFilesCount: 'Selected file count',
    forwardProcess: 'Forwarding Process',
    forwardStep1: 'Select target users (multiple selection available)',
    forwardStep2: 'The system will copy files to target users\' group spaces',
    forwardStep3: 'Target users can view and manage these files in their group spaces',
    selectedUsersCount: 'Selected users',
    moreUsers: 'More',
    forwardNoteTitle: 'Precautions',
    forwardNote1: 'Files will be forwarded to the target user\'s default group space',
    forwardNote2: 'Target users must have joined at least one group space',
    forwardNote3: 'You will lose control over these files after forwarding',
    forwardNote4: 'Forwarding operation cannot be undone; please choose carefully',

    deleteConfirmContent: 'Permanent Delete',
    forwardDescription: 'Forward selected files from your personal space to target shared space',
    forwardInstructions: 'Forwarding Instructions',
    forwardDetails: 'Files will be copied to the root directory of the target space, retaining the original file names. If a file with the same name already exists in the target space, the system will automatically add a suffix to avoid overwriting.',
    forwardPartialSuccess: 'Partial success: {0} space(s) succeeded, {1} failed',
    confirmForward: 'Confirm Forward',
    
    uploadPermissionHint: 'Can only forward to spaces where you have upload permission (administrator, read-write, upload preview roles)',
    
    selectTargetSpace: 'Please first select the space to forward to',
    selectTargetSpaceWithCount: 'Select Target Space',
    
    loadedSpacesCount: 'Loaded spaces',
    loadingSpaces: 'Loading space list...',
    
    noUploadPermissionSpaces: 'You have not joined any shared spaces with upload permission',
    noMatchingSpace: 'No matching space found',
    
    selectedSpacesCount: 'Selected spaces',
    hasUploadPermission: 'Role has upload permission',
    
    // Other needed configurations
    selectUserPlaceholder: 'Please search and select target users',

    writePermissionSpacesHint: 'Only showing shared spaces where you have write permission (read-write or administrator roles)',
    noWritePermissionSpaces: 'No spaces with write permission for now',

    selectSpaceFirst: 'Please first select the space to forward to',
    selectTargetSpaces: 'Select Target Spaces',
    selectSpacePlaceholder: 'Please search and select target spaces',
    allSpaces: 'All Spaces',
    mySpaces: 'Spaces I Have Joined',
    electedSpacesCount: 'Selected spaces',

    previewFile: "Preview File",
    pdfText: "Confidential File - No External Distribution", 
    imageText: "Image Preview",
    documentText: "Document Preview",

    pdfToImage: 'PDF to Image',
    sourceFile: 'Source File',
    imageFormat: 'Image Format',
    storagePath: 'Storage Path',
    inputStoragePath: 'Please enter storage path',
    storagePathTip: 'Converted images will be saved to the specified path',
    losslessCompression: 'Lossless Compression',
    lossyCompression: 'Lossy Compression',
    highQuality: 'High Quality',
    vectorImage: 'Vector Image',
    pleaseInputStoragePath: 'Please enter storage path',
    pdfConvertSuccess: 'PDF conversion successful',
    pdfConvertFailed: 'PDF conversion failed',

    pdfConvertTip: 'Converted images will be downloaded to the browser\'s default download directory',
    browse: 'Browse',
    pleaseSelectStoragePath: 'Please select storage directory',
    multiPageZipDownloaded: 'Multi-page PDF has been converted to a zip file and download has started',
    singlePageDownloaded: 'Single-page PDF has been converted to an image and download has started',

    // New statuses and operations
    pending: 'Pending Approval',
    approved: 'Approved',
    rejected: 'Rejected',
    draft: 'Draft',
    normal: 'Normal',

    outsendApproved: 'External Send Approved',
    outsendRejected: 'External Send Rejected',
    unknownStatus: 'Unknown Status',

    confirmApproval: 'Confirm Approval',
    confirmApproveFile: 'Are you sure you want to approve file?',
    confirmReject: 'Confirm Rejection',
    confirmRejectFile: 'Are you sure you want to reject file?',
    approvalOperation: 'Approval Operation',
    chooseOperationForFile: 'Please select the operation for file',
    pass: 'Pass',
    reject: 'Reject',

    approveSuccess: 'File approved',
    rejectSuccess: 'File has been rejected',

    mobileApprovalTip: 'Click "Pending Approval" status for approval operation',
  },
  router: {
    allFiles: 'All Files',
    fileDetail: 'File Details',
    login: 'Login',
    autoLogin: 'Auto Login',
    register: 'Register',
    users: 'User List',
    userDetail: 'User Details',
    changePassword: 'Change Password',
    editUser: 'Edit User',
    createUser: 'Create User',
    shareDetail: 'Share Details',
    myShare: 'My Shares',
    dashboard: 'System Overview',
    install: 'Install Platform',
    setting: 'System Settings',
    fileslog: 'File Logs',
  },
  preference: {
    /* ================== 原有字段 ================== */
    basic: 'Basic Settings',
    preview: 'Preview Settings',
    scan: 'Scan Disk (immediate scan is global, automatic scanning can be scoped)',
    websiteName: 'Platform Name',
    logo: 'Logo',
    antivirusUpdate: 'Virus Database Management',
    manualUpdate: 'Manual Update',
    manualUpdateTip: 'Execute freshclam command to update virus definitions online',
    uploadVirusDb: 'Offline Database Upload',
    uploadPackage: 'Upload Archive',
    uploadVirusDbTip: 'Upload virus database archive (supports .zip/.tar.gz) for offline environments',
    virusDbUpdateSuccess: 'Virus database updated successfully',
    virusDbUpdateFailed: 'Virus database update failed, please check system logs',
    virusDbUploadSuccess: 'Virus database uploaded and extracted successfully',
    virusDbUploadFailed: 'Virus database upload failed, please check file format',
    invalidVirusDbPackage: 'Invalid virus database package, please upload a .zip or .tar.gz file',
    syncGeneralTips: 'Target server address is used for all types of sync operations, please ensure the correct server address is filled in',
    syncServerDescription: 'Please enter the complete server address, for example: http://example.com:8010 or http://192.168.1.8:8010',
    userSyncDescription: 'Sync all users from this server to the target server',
    logoSquare: 'Please use a square image for the logo; otherwise, it will be cropped to square when displayed',
    onlyAllowIco: 'Only .ico icons are allowed for upload',
    copyright: 'Copyright Information (supports HTML)',
    extraInfo: 'Filing Information (supports HTML)',
    zipMaxNumLimit: 'File Download Quantity Limit',
    zipMaxSizeLimit: 'File Download Size Limit (Bytes)',
    current: 'Current Value',
    noLimit: 'No Limit',
    userDefaultSizeLimit: 'User Default Total Size Limit (Bytes)',
    matterBinDefaultSaveDay: 'Recycle Bin Default Retention Days',
    enterMatterBinDefaultSaveDay: 'Default recycle bin retention days is required!',
    docLink: 'Documentation Link',
    hwzDocLink: 'http://www.hanweizhe.net',
    allowRegister: 'Allow Self-registration',
    antivirusEnabled: 'Enable Upload Antivirus (may slow down uploads)',
    virusScanTimeout: 'Virus Scan Timeout (seconds)',
    virusScanTimeoutRange: 'Please enter a number between 30 and 3600',
    second: 'sec',
    systemCleanup: 'Reset System',
    systemCleanupDescription: 'Resetting the system will clear all data except for administrator accounts',
    systemCleanupPrompt: 'Resetting the system will clear all data except for administrator accounts. This is a major action; please enter the login password',
    previewConfig: 'File Preview Configuration',
    editPreference: 'Set System Parameters',
    editPreviewEngine: 'Set Preview Engine',
    enterWebsiteName: 'Please enter the platform name!',
    enterZipMaxNumLimit: 'ZIP maximum quantity limit is required!',
    enterZipMaxSizeLimit: 'ZIP size limit is required!',
    enterUserDefaultSizeLimit: 'Default user space size is required!',
    engine: 'Preview Engine {}',
    noEngine: 'No online preview engine configuration for now',
    newEngine: 'Add a Preview Engine',
    engineReg: 'Engine Format',
    engineSuffix: 'Matching Suffixes',
    enginePreview: 'Preview Method',
    defaultPreview: 'Default Engine',
    previewEngine: 'Engine {}',
    defaultPreviewDesc: 'Default preview engine, cannot be removed',
    engineRegHelper: 'Template syntax here: {url} represents the file path, which will be automatically replaced with the corresponding file URL during preview; {b64url} represents base64-encoded path, suitable for kkfileview;',
    engineUsageHint: 'For a file preview, the first engine that matches the file suffix is used; if no match is found, the system default preview engine is used',
    engineRegPlaceHolder: 'For example: https://xxx.xxx.xxx?url={url}',
    engineSuffixPlaceHolder: 'Enter suffixes separated by commas, without the dot. For example: doc,ppt,xls',
    previewCurrent: 'Preview on This Site',
    previewOpen: 'Open in New Tab',
    editScan: 'Set Disk Scan',
    enableScan: 'Enable Disk Scan',
    disabledScan: 'Disk scan not enabled yet',
    scanCron: 'Scheduled Scan',
    scanCronValidate: 'Scheduled scan cannot be empty',
    cron: 'Cron Expression',
    cronValidate: 'Cron expression cannot be empty',
    scanScope: 'Scan Scope',
    scanScopeValidate: 'Scan scope cannot be empty',
    scanSpaces: 'Scan Spaces',
    scanPerTenSeconds: 'Every Ten Seconds',
    scanPerThirtySeconds: 'Every Thirty Seconds',
    scanPerMinute: 'Every Minute',
    scanPerHour: 'Every Hour',
    scanCustom: 'Custom',
    chooseSpaces: 'Fuzzy Search Spaces',
    chooseSpacesValidate: 'Please select at least one space',
    scanLoading: 'Scanning in progress, please wait...',
    matterBinDefaultTip: 'Set to 0 to disable the recycle bin function',
    scanImmediately: 'Scan Immediately',
    fullTextSearchEnabled: 'Sensitive Word Check',
    sensitiveWords: 'Sensitive Words',
    scanProgress: 'Scan Progress',
    scanStatus: 'Auto Scan Status',
    scanning: 'Scanning...',
    currentFile: 'Current File',
    close: 'Close',
    enableScanDesc: 'After enabling, the system will automatically perform scans according to the set schedule',
    scanProgressFailed: 'Failed to Get Scan Progress',
    scanFailed: 'Scan Failed',
    scanStartFailed: 'Scan Start Failed',
    scanDisabledHint: 'Auto scan is disabled, scheduled scan tasks will not be executed',
    scanComplete: 'Scan Complete',
    totalFiles: 'Total Files',
    processedFiles: 'Processed Files',
    scanError: 'Scan Error',
    manageSensitiveWords: 'Manage Sensitive Words',
    enterSensitiveWord: 'Enter sensitive word',
    noSensitiveWords: 'No sensitive words for now',
    noSensitiveWordsToExport: 'No sensitive words to export',
    sensitiveWordsImported: 'Successfully imported sensitive words',
    export: 'Export',
    import: 'Import',
    add: 'Add',
    security: 'Security Settings',
    forbiddenKeywords: 'Forbidden Keywords',
    noForbiddenKeywords: 'No forbidden keywords',
    forbiddenExtensionsEnabled: 'Forbidden File Types',
    forbiddenExtensions: 'Extension Settings:',
    manageForbiddenExtensions: 'Manage Forbidden Extensions',
    enterForbiddenExtension: 'Enter extension (without dot)',
    noForbiddenExtensions: 'No forbidden extensions for now',
    noForbiddenExtensionsToExport: 'No forbidden extensions to export',
    forbiddenExtensionsImported: 'Successfully imported forbidden extensions',
    watermarkSet: 'Preview Watermark Settings',
    watermarkEnabled: 'Preview Watermark',
    manageWatermark: 'Manage Watermark',
    enabled: 'Enabled',
    disabled: 'Disabled',
    watermarkPreview: 'Watermark Preview',
    watermarkPreviewContent: 'This is a watermark effect preview page',
    watermarkText: 'Watermark Text',
    enterWatermarkText: 'Please enter watermark text',
    watermarkFontSize: 'Font Size',
    watermarkOpacity: 'Opacity',
    watermarkRotate: 'Rotation Angle',
    watermarkColor: 'Watermark Color',
    showUsername: 'Show Username',
    fileTypeSpecific: 'File Type Specific Settings',
    pdfWatermarkText: 'PDF Watermark Text',
    enterPdfWatermarkText: 'Please enter PDF file watermark text',
    imageWatermarkText: 'Image Watermark Text',
    enterImageWatermarkText: 'Please enter image file watermark text',
    documentWatermarkText: 'Document Watermark Text',
    enterDocumentWatermarkText: 'Please enter document file watermark text',
    previewWatermark: 'Preview Watermark Effect',
    version: 'Version Number',
    dbType: 'Database Type',
    SyncSet: 'Synchronization Settings',
    targetServerAddress: 'Target Server Address',
    targetServerAddressPlaceholder: 'Please enter target server address, e.g.: http://192.168.1.100:8010',
    enterServerAddress: 'Please enter target server address',
    invalidServerAddressFormat: 'Server address format is incorrect; please start with http:// or https://',
    syncing: 'Synchronizing...',
    syncAllUsers: 'Synchronize All Users',
    syncDescription: 'Synchronize all local users to the target server; users with the same name will be skipped automatically',
    syncCompleted: 'User synchronization completed',
    syncFailed: 'User synchronization failed: ',
    autoSyncNewFilesHint: 'Enable auto-synchronization for new files from the same user',
    syncOnlyApprovedFilesHint: 'Only synchronize files after external send approval',
    saveSettings: 'Save Settings',
    autoSyncNewFilesDescription: 'User-uploaded new files will be automatically synchronized to the target server',
    syncOnlyApprovedFilesDescription: 'Only synchronize files that have passed the external send approval process to ensure data security',
    dailyAtMidnight: 'Daily at 00:00',
    every6Hours: 'Every 6 hours',
    every12Hours: 'Every 12 hours',
    weeklyOnSunday: 'Weekly on Sunday at 00:00',
    pdfWatermarkColor: 'PDF Watermark Color',
    imageWatermarkOpacity: 'Image Watermark Opacity',
    customColorPlaceholder: 'Custom color, format: rgba(255,255,255,0.5)',
    invalidColorFormat: 'Please enter a valid color value, e.g., rgba(255,255,255,0.5)',
    defaultWatermarkText: 'Preview File',
    defaultPdfWatermarkText: 'Confidential Document - Do Not Redistribute',
    defaultImageWatermarkText: 'Image Preview',
    defaultDocumentWatermarkText: 'Document Preview',
    watermarkSavePartialSuccess: 'Basic settings saved successfully, but watermark configuration failed to save',
    more: 'More',
    favicon: 'Icon',
    currentCount: 'Current Quantity',
    autoClean: 'Auto Clean',
    cleanBeforeDays: 'Clean files older than (days)',
    day: 'day(s)',
    autoCleanWarning: 'Auto Clean Warning',
    autoCleanWarningDesc: 'This operation will automatically clean files that meet the conditions. Once cleaned, files cannot be recovered. Please configure carefully.',
    autoCleanCaution: 'Please ensure you understand the impact of this function and set the cleanup days with caution.',
    autoCleanDesc: 'After enabling, the system will automatically clean up files older than the specified number of days (not recommended for non-data-transfer environments)',
    cleanBeforeDaysDesc: 'Files older than the specified number of days will be cleaned. For example, if set to 30 days, files older than 30 days will be cleaned.',
    autoCleanWarningDescText: 'Enabling automatic cleanup will permanently delete files older than the specified number of days. Deleted files cannot be recovered. Please proceed with caution!',
    syncAllDepts: 'Sync All Departments',
    deptSyncDescription: 'Sync department data from target server to this system',
    deptSync: 'Department Sync',
    userSync: 'User Sync',
    autoSync: 'Auto Sync',
    deptSyncTips: 'Department sync will synchronize departments from this system to the target server, including department hierarchy',
    userSyncTips: 'User sync will synchronize users from this system to the target server',
    deptSyncConfirm: 'Confirm Department Sync',
    deptSyncConfirmContent: 'This operation will retrieve department data from target server and update to this system, continue?',
    deptSyncCompleted: 'Department sync completed, success: {0}, total: {1}',
    deptSyncFailed: 'Department sync failed',
    userSyncCompleted: 'User sync completed',
    basicSettings: 'Basic Settings',
    advancedSettings: 'Advanced Settings',
    platformIpSettings: 'Platform IP Address',
    currentPlatformIp: 'Current IP Address',
    newPlatformIp: 'New IP Address',
    saveIp: 'Save IP',
    enterPlatformIp: 'Please enter IP address',
    invalidIpFormat: 'Invalid IP address format',
    pleaseEnterPlatformIp: 'Please enter the IP address.',
    operationFailed: 'Operation failed.',
    updateIpFailed: 'Failed to update IP',
    fetchFailed: 'Failed to fetch',
    loading: 'Loading...',
    notConfigured: 'Not configured',
    platformIpTips: 'This affects the external access address of the platform. Please operate with caution.',
    advancedSettingsDisabled: 'Advanced Settings Disabled',
    advancedSettingsDisabledDesc: 'Scan and sync features are unavailable under current system configuration.',
    deptSyncCompletedGeneric: 'Department sync completed',
    scanStarting: 'Starting scan...',
    ipWithNetmask: 'IP Address/Netmask',
    ipWithNetmaskPlaceholder: 'e.g. 192.168.1.100/24 or 192.168.1.100 (default /24)',
    gateway: 'Gateway Address',
    gatewayPlaceholder: 'e.g. 192.168.1.1',
    dns: 'DNS Server',
    dnsPlaceholder: 'Separate with commas, e.g. 8.8.8.8,114.114.114.114',
    invalidNetmask: 'Netmask must be a number between 1 and 32',
    invalidGateway: 'Invalid gateway IP address format',
    pleaseRevisitWithNewIp: 'Please revisit the system using the new IP address {ip}.',
    platformIpUpdated: 'Platform IP updated successfully',
    resetSyslogTime: 'Reset Syslog Time',
  resetSyslogConfirmTitle: 'Confirm Reset',
  resetSyslogConfirmContent: 'After reset, the forwarder will start reporting logs from the last 24 hours, which may cause duplicate data. Are you sure?',

  
    /* ================== 新增字段 ================== */
    securityAppSettings: 'Security App Settings',
    forceAutoUpload: 'Force Auto Upload',
    forceAutoUploadDesc: 'Automatically upload files from client to server',
    appsecOnly: 'Only allow encrypted-environment APP login',
    appsecOnlyDesc: 'When enabled, PC client login must carry the encrypted-environment flag, otherwise login is rejected',
    uploadDirectories: 'Upload Directories (for Desktop, just enter "Desktop")',
    addDirectory: 'Add Directory',
    noUploadDirectories: 'No directories configured',
    enterDirectoryPath: 'Please enter directory path',
    save: 'Save',
    delete: 'Delete',
    fileTypes: "File Types",
    addFileType: "Add Type",
    noFileTypes: "No types configured",
    enterFileType: "Enter file extension (e.g. .txt)",
    fileTypeExists: "File type already exists",
    syslogSettings: "Syslog Reporting Settings",
    syslogEnable: "Enable Reporting",
    syslogServer: "Syslog Server Address",
    syslogServerPlaceholder: "Example: 192.168.1.100 or syslog.example.com",
    syslogPort: "Port",
    syslogCron: "Reporting Frequency (Cron)",
    syslogCronPlaceholder: "Example: */5 * * * * (Every 5 minutes)",
    syslogBatchSize: "Maximum Records per Report",
    syslogDescription: "Once enabled, local audit logs will be periodically converted to standard Syslog format and sent to the specified server.",
    cascadeSettings: "Cascade Settings",
    cascadeSettingsDesc: "After configuring the upstream server IP address, this platform can report data to the upstream platform or sync configurations from it.",
    upstreamServer: "Upstream Server IP",
    upstreamServerPlaceholder: "Enter upstream server address, e.g., http://192.168.1.100:8010",
    upstreamServerTips: "Leave empty to indicate no upstream server. Ensure the address is accessible and includes protocol (http:// or https://) and port number.",
    systemUpgrade: "System Upgrade",
    systemUpgradeDesc: "Upload a frontend upgrade package or client installer; it takes effect immediately (refresh the page to load the new frontend).",
    frontendUpgrade: "Frontend Package",
    frontendUpgradeTip: "Upload the frontend build output (.zip). The package should contain index.html and the static/ directory; it will be extracted to replace the web UI.",
    pcUpgrade: "PC Client Upgrade",
    pcUpgradeTip: "Upload the PC client installer (.msi). It will be saved as html/APP/HWZWinApp.msi with the version entered on the right; clients use the version to decide whether to upgrade.",
    pcVersionPlaceholder: "Version (required)",
    pcVersionRequired: "Please enter the version number before uploading the PC client installer",
    mobileUpgrade: "Mobile Client Upgrade",
    mobileUpgradeTip: "Upload the Android client installer (.apk). It will be saved as html/APP/AndroidApp.apk.",
    choosePackage: "Choose File",
    invalidFrontendPackage: "Invalid package, please upload a .zip file",
    invalidPcPackage: "Invalid installer, please upload a .msi file",
    invalidMobilePackage: "Invalid installer, please upload a .apk file",
    upgradeFrontendSuccess: "Frontend package uploaded and extracted successfully",
    upgradeFrontendFailed: "Frontend package upload failed",
    upgradePcSuccess: "PC client package uploaded successfully",
    upgradePcFailed: "PC client package upload failed",
    upgradeMobileSuccess: "Mobile client package uploaded successfully",
    upgradeMobileFailed: "Mobile client package upload failed",
    overallUpgrade: "Overall Upgrade",
    backupNow: "Back Up Now",
    backupLoading: "Backing up, please wait…",
    backupRunning: "Backup in progress",
    backupSuccess: "Backup completed",
    backupFailed: "Backup failed",
    backupDir: "Backup Directory",
    backupRecords: "Backup Records",
    backupRefresh: "Refresh",
    backupEmpty: "No backup records. Click \"Back Up Now\" to start.",
    backupLoadFailed: "Failed to load backup records",
    backupConfirmTitle: "Start the backup?",
    backupConfirmContent: "Backup includes database, file data, config and licence; time depends on data size. Do not perform other operations while backing up.",
    backupViewLog: "View Backup Log",
    backupClose: "Close",
    overallStepBackup: "① Back up data",
    overallStepUninstall: "③ Uninstall old version",
    overallStepInstall: "④ Install new version and restore",
    fullUpgradeStart: "Upload Package & Start Overall Upgrade",
    fullUpgradeStartDesc: "Upload the new package (.tar.gz); the system will automatically run: backup → uninstall old version → install new version (incl. MySQL reinstall) → restore data. You will be prompted to revisit the site when done; only on failure do you need to log into the server console.",
    fullUpgradeRestoreDir: "Restore backup directory (optional)",
    fullUpgradeRestoreDirTip: "Leave empty to use the latest backup automatically, or specify a /HwzDiskbak/hwzbak_* directory",
    fullUpgradeInvalidPackage: "Invalid package, please upload a .tar.gz file",
    fullUpgradeConfirmTitle: "Start the overall upgrade?",
    fullUpgradeConfirmContent: "The system will automatically run: backup → uninstall → install new version (incl. MySQL reinstall) → restore data. The service will be interrupted; progress is shown on this page. After completion, revisit the site to verify. Do not close the browser and keep the network stable during the upgrade.",
    fullUpgradeStarted: "Overall upgrade started",
    fullUpgradeStartFailed: "Failed to start overall upgrade",
    fullUpgradeRunning: "Overall upgrade in progress",
    fullUpgradeProgress: "Upgrade Progress",
    fullUpgradeLog: "Upgrade Log",
    upgradeStateBackingUp: "Backing up data...",
    upgradeStateUninstalling: "Uninstalling old version...",
    upgradeStateInstalling: "Installing new version and MySQL, this may take a while...",
    upgradeStateRestoring: "Restoring data...",
    upgradeStateDone: "Upgrade completed",
    upgradeStateFailed: "Upgrade failed",
    upgradeRestarting: "Service is restarting, please wait...",
    upgradeDoneContent: "Overall upgrade completed. Please revisit {0} to verify the system.",
    upgradeFailedContent: "Overall upgrade failed. Please log into the server console, check /tmp/hwz_full_upgrade.log, complete the upgrade manually, then revisit the site.",
    overallStepRestore: "④ Restore data",
    visitAgain: "Revisit Site",
    fullUpgradeUploading: "Starting upgrade task..."
  },
systemLog: {
    // Titles & Fields
    title: 'System Logs',
    module: 'Module',
    operation: 'Operation',
    user: 'User',
    targetType: 'Target Type',
    targetName: 'Target Name',
    detail: 'Details',
    ip: 'IP Address',
    createTime: 'Timestamp',
    logType: 'Log Type',
    alarmLevel: 'Alarm Level',
    extraData: 'Extra Data',
    keyword: 'Keyword',
    keywordPlaceholder: 'Username, target name, details, etc.',
    unknownUser: 'Unknown User',
    unknownTarget: 'Unknown Target',
    uuidNotSpecified: 'UUID not specified. Unable to retrieve details!',
    // Operations (新增部分 - 英文)
    operationBatchCreate: 'Batch Create',
    operationBatchDelete: 'Batch Delete',
    operationBatchUpdate: 'Batch Update',
    operationTransfiguration: 'Transform',  // 建议使用 Transform 而非 Transfigure
    operationScan: 'Scan',
    operationSync: 'Sync',
    operationExecute: 'Execute',
    viewDetail: 'View Details',
    basicInfo: 'Basic Info',
    changeDetails: 'Change Details',

    close: 'Close',
    // Modules
    moduleAuth: 'Authentication',
    moduleUser: 'User Management',
    moduleDepartment: 'Department Management',
    moduleSpace: 'Space Management',
    moduleSystem: 'System Settings',
    moduleRole: 'Role & Permissions',
    moduleLog: 'Log Management',
    moduleBackup: 'Backup & Restore',
    moduleAlarm: 'Alert Management',
    usernamePlaceholder: 'Enter username',
    moduleShare: "Sharing Module",
moduleSync: "Synchronization Module",
moduleOther: "Other Modules",
moduleFile: "File Module",
moduleSecurity: "Security Module",
moduleStorage: "Storage Module",
    // Operations
    operationLogin: 'Login',
    operationLogout: 'Logout',
    operationLoginFailed: 'Login Failed',
    operationCreate: 'Create',
    operationUpdate: 'Update',
    operationDelete: 'Delete',
    operationEnable: 'Enable',
    operationDisable: 'Disable',
    operationResetPassword: 'Reset Password',
    operationChangePassword: 'Change Password',
    operationImport: 'Import',
    operationExport: 'Export',
    operationBackup: 'Backup',
    operationRestore: 'Restore',
    operationClean: 'Clean',
    operationConfigUpdate: 'Configuration Updated',
    operationRoleAssign: 'Assign Role',
    operationPermissionGrant: 'Grant Permission',
    operationPermissionRevoke: 'Revoke Permission',
  
    // Target Types
    targetTypeUser: 'User',
    targetTypeDepartment: 'Department',
    targetTypeSpace: 'Space',
    targetTypeSpaceMember:'Space Member',
    targetTypeShare:'Share',
    targetTypeSystem: 'System',
    targetTypeRole: 'Role',
    targetTypeLog: 'Log',
    targetTypeBackup: 'Backup',
    targetTypeSetting: 'Setting',
    targetTypeSystemTask:'System Task',
    // Log Types
    logTypeNormal: 'Normal',
    logTypeWarning: 'Warning',
    logTypeError: 'Error',
  
    // Alarm Levels
    alarmLevelNone: 'None',
    alarmLevelWarning: 'Warning',
    alarmLevelError: 'Error',
    alarmLevelCritical: 'Critical',
  
    // Action Buttons
    export: 'Export',
    clean: 'Clean',
    statistics: 'Statistics',
    refresh: 'Refresh',
    advancedFilter: 'Advanced Filter',
    timeRange: 'Time Range',
    selectModule: 'Select Module',
    selectOperation: 'Select Operation',
    selectTargetType: 'Select Target Type',
    selectLogType: 'Select Log Type',
    selectAlarmLevel: 'Select Alarm Level',
    search: 'Search',
    reset: 'Reset',
  
    // Statistics
    statisticsTitle: 'Statistics',
    statisticsTotalOperations: 'Total Operations',
    statisticsWarningCount: 'Warnings',
    statisticsErrorCount: 'Errors',
    statisticsPeriod: 'Period',
    statisticsRecentAlarms: 'Recent Alarms',
    statisticsModuleStats: 'Module Statistics',
  
    // Export Messages
    exportSuccess: 'Export successful',
    exportFailed: 'Export failed',
    exportConfirm: 'Are you sure you want to export system logs?',
  
    // Clean Messages
    cleanSuccess: 'Cleanup successful',
    cleanFailed: 'Cleanup failed',
    cleanConfirm: 'Are you sure you want to clean logs older than {keepDays} days?',
    cleanKeepDays: 'Retention Days'
  },
  share: {
    shareDetail: 'Share Details',
    shareTime: 'Share Time',
    expireTime: 'Expiration Time',
    noExpire: 'Permanent',
    expired: 'Expired',
    copyLinkAndCode: 'Copy Link + Extraction Code',
    shareSuccess: 'Share Successful',
    sharer: 'Sharer',
    noValidFiles: 'No valid files to share.',
    link: 'Link',
    copyLink: 'Copy Link',
    code: 'Extraction Code',
    copyCode: 'Copy Extraction Code',
    copySuccess: 'Copy Successful',
    more: 'More',
    cancelShare: 'Cancel Share',
    getLink: 'Get Link',
    allFiles: 'All Files',
    noContent: 'No content in this directory yet',
    enterCode: 'Please enter the extraction code',
    getFiles: 'Extract Files',
    codeError: 'Extraction code error',
    cancelPrompt: 'This operation will permanently cancel this share. Continue?',
    hour: '1 Hour',
    day: '1 Day',
    week: '1 Week',
    month: '1 Month',
    year: '1 Year',
    infinity: 'Permanent',
    emptyHint: 'No shares yet',
    myShareToOthers: 'My Shares to Others',
    othersShareToMe: 'Others\' Shares to Me',
    sharedToMeEmptyHint: 'No files shared with you by others yet',
    deleteConfirm: 'Are you sure you want to delete this share?',
    copyTip: "Please copy the link and extraction code below to share with others",
    detail: 'Details',
    createTime: 'Creation Time',
    downloadTimes: 'Download Count',
    private: 'Private Share',
    public: 'Public Share',
    shareTo: 'Share to',
    publicLink: 'File External Link',
    privateShare: 'Specified User Share',
    selectUsers: 'Select Users',
    selectSpaces: 'Select Groups',
    selectUsersPlaceholder: 'Please select users to share with',
    selectSpacesPlaceholder: 'Please select groups to share with',
    selectedTargets: 'Selected Share Targets',
    createPrivateShare: 'Create Private Share',
    selectUserOrSpace: 'Please select at least one user or group',
    createSuccess: 'Share created successfully',
    createFailed: 'Share creation failed',
    publicSharePrompt: 'Create a public share link; anyone can access it via the link and extraction code',
    createPublicShare: 'Create Public Share',
    publicShareNotCreated: 'Please create a public share first',
    copyPublicSuccess: 'Public share link and extraction code have been copied to clipboard',
    permission: 'Permission Settings',
    permissionView: 'Preview Permission',
    permissionViewDesc: 'Only allows viewing and downloading files',
    permissionAll: 'Full Permissions',
    permissionAllDesc: 'Allows viewing, downloading, editing, and deleting files',
    shareLinkAndCode: "Share Link and Extraction Code",
    copyLinkSuccess: "Link copied successfully",
    copyCodeSuccess: "Extraction code copied successfully",
    copyLinkAndCodeSuccess: "Link and extraction code copied successfully",
    noPassword: "No Password",
    unknown: "Unknown",
    name: "Share Name",
    shareScope: "Share Scope",
    privateShareDetail: "Private Share Details",
    targetUsers: "Target Users",
    targetSpaces: "Target Spaces",
    noTargetUsers: "No target users specified",
    noTargetSpaces: "No target spaces specified",
    noPermission: "No Access Permission",
    clickToPreview: 'Click to Preview',
    previewOnly: 'Preview Only',
    previewOnlyNoDownload: 'This share is set to preview only; file download is disabled',
    fullPermission: 'Full Permission',
    directPreview: 'Direct Preview',
    isSharedToMe: 'Shared To Me',
  },
  color: {
    grayTransparent: 'Gray Transparent',
    redTransparent: 'Red Transparent',
    blueTransparent: 'Blue Transparent',
    greenTransparent: 'Green Transparent',
    orangeTransparent: 'Orange Transparent',
    purpleTransparent: 'Purple Transparent',
    blackTransparent: 'Black Transparent',
    whiteTransparent: 'White Transparent'
  },
  user: {
    redirecting: 'Redirecting...',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    cannotBeNull: 'Cannot be empty!',
    passwordNotSame: 'Two inputs do not match!',
    role: 'Role',
    unknown: 'Unknown User',
    deptSelectWarning: 'When an administrator selects a department, their role will be downgraded to department administrator, with user management permissions limited to that department only!',
    adminDeptWarning: 'Built-in super administrators have global permissions and cannot be assigned to a department!',
    adminDeptChangeError: 'Built-in super administrators have global permissions and cannot be assigned to a department!',
    deptSelectHint: 'When an administrator selects a department, their role will be downgraded to department administrator, with user management permissions limited to that department only!',
    adminNoDept: 'Built-in super administrators are not restricted to any department',
    singleFileSizeLimit: 'Single File Limit',
    totalFileSizeLimit: 'Space Limit',
    usernamesearch: 'Search by Username',
    current: 'Current Value',
    noLimit: 'No Limit',
    readWriteDesc: 'Can upload, preview, download, and delete files',
    uploadPreview: 'Upload and Preview Permission',
    uploadPreviewDesc: 'Can upload and preview files, but cannot download',
    readOnly: 'Read Only',
    readOnlyDesc: 'Only download and preview permissions, no upload, delete, or rename access.',
    userLimitTypeHint: 'Set mobile storage access and operation permissions (requires mobile storage module configuration)',
    totalFileSize: 'Used Space',
    webAllowedIpRange: "Web Client IP Range",
    pcAllowedIpRange: "PC Client IP Range",
    webIpRangeTip: "Web client allowed login IP range, supports CIDR format, multiple ranges separated by commas, e.g.: 192.168.1.0/24,10.0.0.0/16",
    pcIpRangeTip: "PC client allowed login IP range, supports CIDR format, multiple ranges separated by commas, e.g.: 192.168.1.0/24,10.0.0.0/16",
    status: 'Status',
    lastLogin: 'Last Login',
    lastLoginIp: 'Last Login IP',
    lastLoginTime: 'Last Login Time',
    resetPassword: 'Reset Password',
    transfiguration: 'Switch User',
    changePassword: 'Change Password',
    enterPassword: 'Enter Password',
    enterUsername: 'Please enter username',
    enterNewPassword: 'Please enter new password',
    profile: 'Profile',
    avatar: 'Avatar',
    username: 'Username',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    disabled: 'Disabled',
    disableUser: 'Disable this user',
    activeUser: 'Activate this user',
    deleteUser: 'Delete this user',
    deleteHint: 'This operation will delete all records of the user, including files, shares, user information, etc. Confirm to continue?',
    disable: 'Disable',
    sync: 'Synchronize',
    active: 'Activate',
    welcomeLogin: 'Welcome to Login',
    logining: 'Logging in...',
    login: 'Login',
    currentuser: 'Current User',
    loginSuccess: 'Login Successful',
    toToRegister: 'Register Now',
    welcomeRegister: 'Welcome to Register',
    registering: 'Registering...',
    register: 'Register',
    goToLogin: 'Go to Login',
    roleGuest: 'Guest',
    roleUser: 'Registered User',
    roleUserRoleSpace: 'User Space Role',
    roleAdministrator: 'Administrator',
    roleAudit: 'Audit',
    statusActive: 'Normal',
    statusDisabled: 'Disabled',
    webdavLink: 'WebDAV Address',
    webdavHint: 'Use your login username & password to connect via WebDAV clients (e.g., RaiDrive, Cyberduck)',
    docLink: 'Documentation Link',
    createUser: 'Create User',
    editUser: 'Edit User',
    editSomebodyPassword: 'Change user\'s Password',
    transfigurationPromptText: 'Switch User Prompt',
    transfigurationPrompt: 'You will log in as this user. Please copy the following link to access in another browser. Accessing in the current browser will invalidate the current user\'s login information.',
    searchUser: 'Search User',
    allowedDevices: "Secure Login Settings:",
    allowedDevicesHint: "Set login type characteristics and range (Note: Unset types restrict login)",
    webClient: "Web Client", 
    pcClient: "PC Client",  
    mobileClient: "Mobile Client",  
    allowedIpRange: "Allowed IP Range for Login",  
    ipRangeTip: "Supports CIDR format; multiple ranges separated by commas, e.g.: 192.168.1.0/24,10.0.0.0/16",
    bindDeviceFeature: "Bind Device Feature",
    loginFailed: "Login Failed",
    downloadTemplate: 'Download Template',
    templateDownloadSuccess: 'Template downloaded successfully',
    templateDownloadFailed: 'Template download failed',
    importCreateUsers: 'Import Batch Creation',
    disableShare: 'Disable Sharing/Forwarding',
    shareSettings: 'Sharing Settings',
    setShare: "Sharing Permissions",
    shareEnabled: "Sharing Enabled",
    disableShareHint: 'Completely prohibit the user from any form of sharing',
    disablePublicShare: 'Disable Public Sharing',
    publicShareEnabled: 'Enable Public Sharing',
    disablePublicShareHint: 'Only allow private sharing; prohibit creating public share links',
    publicShareEnabledHint: 'Allow private sharing and public share links',
    batchCreateConfirm: 'Batch Creation Confirmation',
    willCreateUsers: 'Will batch create users',
    defaultPassword: 'Default Password',
    batchCreateStart: 'Batch creation started',
    batchCreateFailed: 'Batch creation failed',
    batchCreatePartial: 'Batch creation incomplete',
    batchCreateSuccess: 'Batch creation successful',
    exportSuccess: 'Export successful',
    department: 'Affiliated Department',
    selectDepartment: 'Select Department',
    departmentId: 'Department ID',
    webModeAgentHint: 'WEB mode is enabled; a secure login agent needs to be installed.',
    noDeptData: 'No department data available',
    noMatchingDept: 'No matching department found',
    userLimitType: 'Removable Disk Permission',
    // 以下是新添加的英文字段
    bindWebFeature: "Web Client Feature Binding",
    bindPcFeature: "PC Client Feature Binding", 
    bindWebFeatureTip: "Web client requires installation of secure login Agent",
    bindPcFeatureTip: "PC client requires installation of secure login Agent",
    noIpRangeSet: "Not Set",
    onlineForceAutoUpload: 'Force Auto Upload',
    onlineSend: 'Send',
    onlineWebNoSupport: 'This feature is only supported for PCAPP clients',
    onlineforceLogout: 'Force Offline',
    onlineconfirmLogout: 'Are you sure you want to force this user offline?',
    onlineloginTime: 'Login Time',
    onlinedeviceInfo: 'Device Info',
    onlinestatus: 'Online Status',
    onlinestatusOnline: 'Online',
    onlinestatusExpired: 'Expired',
    onlinerefreshList: 'Refresh List',
    onlinecurrentOnline: 'Currently Online',
    onlinepeople: 'People Online',
    expirationDate: 'Expiration Date',
    permanent: 'Permanent',
    expiredTip: 'Account has expired, please renew',
    expired: 'Expired',
    selectExpirationDate:'Select Expiration Date',
    expirationDateHint: 'Set the validity period of the user account. After expiration, the account will be automatically disabled. Not setting means permanent user.',
  },
  space: {
    spaceName: 'Space Name',
    spaceNameSearch: 'Search by Space Name',
    name: 'Shared Group',
    nameTip: 'Please enter group name; cannot be modified',
    create: 'Create Group',
    editGroup: 'Edit Group',
    viewCard: 'Card View',
    viewList: 'List View',
    totalSize: 'Used',
    unknown: 'Unknown Space',
    sizeLimit: 'Single File Limit',
    sizeLimitTip: 'Please enter single file size limit',
    totalSizeLimit: 'Total Size Limit',
    totalSizeLimitTip: 'Please enter total size limit',
    deleteHint: 'This operation will permanently delete the space. Please delete all files and space members first. Continue?',
    memberManage: 'Group Member Management',
    member: 'Group Member',
    refreshAndClose:"Refresh And Close",
    memberTip: 'Please search and select users',
    memberRole: 'Member Role',
    memberRoleTip: 'Please select member role',
    bindMember: 'Bind Group Member',
    unBindMember: 'Unbind Group Member',
    unBindMemberHint: 'This operation will unbind the space member. Continue?',
    memberRoleReadonly: 'Read-only',
    memberRoleReadWrite: 'Read-write',
    memberRoleAdmin: 'Administrator',
    emptyHint: 'No spaces yet',
    allSpaces: 'All Spaces',
    partialSpaces: 'Partial Spaces',
    memberRolePreviewOnly: 'Preview Only',
    memberRoleUploadPreview: 'Upload + Preview',
    alreadyExistsCount: 'Already exists',
    createdSuccess: 'Created successfully',
    alreadyExists: 'Already exists',
    batchCreateWithExists: 'Batch creation completed. Successfully created {0} spaces, {1} departments already had spaces',
    batchCreatePartialSuccess: 'Batch space creation partially successful. Successfully created {0}, {1} already existed, {2} failed',
    memberManagement: 'Member Management',
    // Member statistics related
    memberStats: 'Member Statistics',
    totalMembers: 'Total Member Count',
    deptMembers: 'Department Members',
    manualMembers: 'Manually Added',
    boundDepts: 'Bound Departments',
    deptMemberPercentage: 'Department Member Percentage',
    // Synchronization related
    syncMembers: 'Synchronize Members',
    batchSetRole: 'Batch Set Role',
    // Batch operation confirmation messages - Fixed text as per Chinese version
    partialSuccess: 'Partial success',
    syncFailed: 'Synchronization Failed',
    // Department binding related - Fixed text as per Chinese version
    boundDepartmentsCount: 'Bound Departments',
    batchAddByDept: 'Batch Add by Department',
    batchAddDeptHint: 'Select the departments to add; the system will automatically add all users under those departments to the current space',
    // Role setting
    setRole: 'Set role as:',
    selectedDepartmentsCount: 'Selected departments',
    // Bind member confirmation - Fixed text as per Chinese version
    bindMemberConfirm: 'Are you sure you want to add the selected departments?',
    // New role description fields
    memberRolePreviewOnlyDesc: 'Can only preview files, cannot upload or download',
    memberRoleUploadPreviewDesc: 'Can upload and preview files',
    memberRoleReadonlyDesc: 'Can only view files, cannot edit',
    memberRoleReadWriteDesc: 'Can view and edit files',
    memberRoleAdminDesc: 'Space administrator, has all permissions',
    deleteDeptMemberWarningFull:'Delete shared group member',
    batchCreate: 'Batch Create',
    batchCreateTitle: 'Batch Create Spaces',
    batchCreateHint: 'Batch Create Instructions',
    batchCreateDescription: 'Select multiple departments, and the system will create a shared space for each selected department. You can configure the basic settings for the spaces as needed.',
    selectDepartments: 'Select Departments',
    selectDeptHint: 'Select departments to create spaces for (multiple selections allowed)',
    selectedDeptCount: 'Selected departments',
    spaceConfigTemplate: 'Space Configuration Template',
    nameTemplate: 'Space Name Template',
    nameTemplatePlaceholder: 'e.g., {Department Name} Shared Space, supports {deptName} placeholder',
    nameTemplateHint: 'Hint: {deptName} will be replaced with the department name',
    zipMaxSize: 'ZIP Package Maximum Size',
    enterZipMaxSize: 'Please enter the maximum ZIP package size',
    recycleKeepDays: 'Recycle Bin Retention Days',
    enterRecycleDays: 'Please enter the number of days to retain items in the recycle bin',
    batchCreatePreview: 'Batch Create Preview',
    willCreateSpacesForDepts: 'Will create spaces for the following departments:',
    andMoreDepts: 'and other departments',
    batchCreateConfirm: 'Batch Create Spaces Confirmation',
    batchCreateDeptCount: 'Will batch create spaces for the selected departments:',
    batchCreateConfig: 'Configuration Information:',
    startBatchCreate: 'Start Batch Creation',
    selectDeptForBatchCreate: 'Please select departments to create spaces for',
    enterSpaceNameTemplate: 'Please enter a space name template',
    batchCreateSuccessAll: 'Batch creation successful',

    batchCreateAllFailed: 'Batch creation failed',
    batchCreateFailed: 'Batch creation failed',
    batchCreateError: 'An error occurred during batch space creation',
    batchCreateResults: 'Batch Creation Results',
    successCount: 'Success',
    failedCount: 'Failed',
    success: 'Success',
    failed: 'Failed',
    copySuffix: ' (Copy)',
    configCopied: 'Space configuration copied',
    defaultSuffix: 'Shared Space',
    zipMaxNumLimit: 'ZIP Package Maximum Number of Files',
    enterSizeLimit: 'Please enter the space size limit',
    enterZipMaxNum: 'Please enter the maximum number of files for ZIP packaging',
    autoGenerateNameHint: 'Space name will be automatically generated, format: Department Name + Shared Space',
    autoGenerateNameDesc: 'Space name format: Department Full Name + Department Abbreviation + Shared Space',
    membersAdded: 'Added members',
    membersSkipped: 'Skipped members',
    autoAddMembersHint: 'Automatically add all users under the department as space members after creation',
    autoAddMembersDesc: 'The system will automatically add space member permissions for all users under the department, with the default role being read-only',
    memberUnbind: 'Unbind',
    memberUnbindConfirm: 'Unbind Member',
    memberUnbindConfirmText: 'Are you sure you want to unbind this member?',
    spaceBatchCreateSuccess: 'Batch space creation successful',
    // Fixed text as per Chinese version
    deptAddSuccessLog: 'Department addition successful',
    deptAddFailLog: 'Department addition failed',
    batchAddDeptSuccess: 'Batch addition successful',
    noMemberAdded: 'Operation completed, but no members were added',
    batchAddFail: 'Batch addition failed:',
    deptBindingUpdated: 'Space department binding updated',
    memberUnbindConfirmDesc: 'Are you sure you want to unbind this member?',
    boundDeptCount: 'Bound departments',
    
    // Space related general fields
    processRules: 'Processing Rules',
    addAllUsersInDept: 'Add each department\'s all users',
    skipExistingMembers: 'Skip existing members',
    eachDeptIndependent: 'Each department processed independently, without affecting each other',
    selectedDepts: 'Selected departments',
    subDeptsToAdd: 'Sub-departments',
    totalDeptsToProcess: 'Total departments to process',

    addMode: 'Addition Mode',
    confirmBatchAddDeptMembers: 'Are you sure you want to batch add department members according to the following configuration?',
    startAdd: 'Start Addition',
    // Shared group config import/export
    exportConfig: 'Export Config',
    importConfig: 'Import Config',
    exportSuccess: 'Config exported successfully',
    exportFailed: 'Failed to export config',
    exporting: 'Exporting config...',
    importConfirm: 'Confirm to import shared group config? Existing groups will be skipped, missing groups will be created and members bound',
    importSuccess: 'Import succeeded',
    importFailed: 'Import failed',
    importResult: 'Import finished: {0} groups total, {1} created, {2} skipped, {3} members added',
    importConfigEmpty: 'Please select or paste the config file to import',
    importConfigInvalid: 'Invalid config format, please check the JSON content',
    importConfigPlaceholder: 'Paste the exported JSON config, or pick a config file above',
    selectImportFile: 'Select Config File',
    membersAddedCount: '{0} member(s) added',
    // Cross-group search
    crossGroupSearch: 'Search',
    crossGroupSearchPlaceholder: 'Search files across all shared groups',
    crossGroupSearchTitle: 'Results for “{0}” across shared groups',
    crossGroupScopeHint: 'Scope: all shared groups you have joined',
    crossGroupLoading: 'Searching...',
    crossGroupEmpty: 'No matching files found',
    crossGroupSearchFailed: 'Cross-group search failed',
    crossGroupKeywordEmpty: 'Please enter a search keyword',
    crossSearchGroupName: 'Group',
    crossSearchSize: 'Size',
    crossSearchDirectory: 'Folder',
  },
  model: {
    usernameRule: 'Username can only contain letters, numbers, and "_"',
    passwordRule: 'Password length must be at least 6 characters',
    linkCodeText: 'Link:{} Extraction Code:{}',
    copyLinkCodeSuccess: 'Copy link and extraction code successful',
  },
  error: {
    // Basic errors
    badRequest: 'Request parameter error',
    needShareCode: 'Share code required',
    shareCodeError: 'Share code error',
    notLogin: 'Not logged in',
    userDisabled: 'User has been disabled',
    unauthorized: 'Unauthorized access',
    notFound: 'Resource does not exist',
    methodNotAllowed: 'Request method not allowed',
    conflict: 'Resource conflict',
    preconditionFailed: 'Precondition failed',
    unsupportedMediaType: 'Unsupported media type',
    rangeNotSatisfiable: 'Request range cannot be satisfied',
    notInstalled: 'Application not installed',
    serverError: 'Server internal error',
    unknownError: 'Server unknown error',
    networkError: 'Network connection failed; please check network settings',
    clientError: 'Client error: {}',
    
    // Operation related errors
    operationFailed: 'Operation failed',
    uploadFailed: 'Upload failed',
    downloadFailed: 'Download failed',
    deleteFailed: 'Delete failed',
    renameFailed: 'Rename failed',
    moveFailed: 'Move failed',
    copyFailed: 'Copy failed',
    shareFailed: 'Share failed',
    previewFailed: 'Preview failed',
    
    // File related errors
    fileNotFound: 'File does not exist',
    fileSizeExceeded: 'File size exceeds limit',
    fileTypeNotAllowed: 'File type not allowed',
    directoryNotEmpty: 'Directory is not empty',
    
    // Space related errors
    spaceNotFound: 'Space does not exist',
    noSpacePermission: 'No space access permission',
    spaceQuotaExceeded: 'Space capacity insufficient',
    
    // User related errors
    userNotFound: 'User does not exist',
    usernameExists: 'Username already exists',
    passwordIncorrect: 'Password error',
    passwordTooSimple: 'Password too simple',
    
    // System errors
    systemBusy: 'System busy; please try again later',
    databaseError: 'Database error',
    configurationError: 'Configuration error',
    
    // Validation errors
    invalidInput: 'Input content invalid',
    requiredField: 'Required field cannot be empty',
    invalidFormat: 'Format incorrect',
    outOfRange: 'Value out of range',
    
    // Session errors
    sessionExpired: 'Session expired; please log in again',
    tooManySessions: 'Session count reached limit',
    
    // Approval related errors
    approvalPending: 'Approval pending',
    approvalRejected: 'Approval rejected',
    approvalNotFound: 'Approval record does not exist',
    
    // Synchronization related errors
    syncFailed: 'Synchronization failed',
    syncConflict: 'Synchronization conflict',
    
    // External send related errors
    outsendNotAllowed: 'File external send not allowed',
    outsendApprovalRequired: 'External send approval required',
    
    // Department related errors
    deptNotFound: 'Department does not exist',
    deptIdRequired: 'Please select a department',
    deptMemberStatError: 'Failed to get department member statistics',
    deptBatchAddError: 'Failed to batch add department members',
    deptSyncError: 'Failed to synchronize department members',
    deptBatchRemoveError: 'Failed to batch remove department members',
    deptBatchUpdateRoleError: 'Failed to batch update department member roles',
    // Space member related errors
    spaceMemberExist: 'Space member already exists',
    spaceMemberStatError: 'Failed to get space member statistics',
    spaceMemberBatchAddError: 'Failed to batch add space members',
    spaceMemberSyncError: 'Failed to synchronize space members',
    spaceMemberBatchRemoveError: 'Failed to batch remove space members',
    spaceMemberBatchUpdateRoleError: 'Failed to batch update department member roles',
    leafNodeCount: "Leaf nodes: {0}",
    nonLeafNodeCount: "Non-leaf nodes: {0}",
    leafNode: "Leaf node",
    nonLeafNode: "Non-leaf node",
    pathLabel: "Path",
    conversionFailed: 'Conversion failed',
    conversionNotSupported: 'File conversion not supported',
    conversionTimeout: 'File conversion timeout',
    conversionFormatError: 'File format conversion error',
    
    // New errors
    spaceNameRequired: 'Space name cannot be empty',
    spaceSizeLimitRequired: 'Space size limit cannot be empty',
 

    spaceBatchCreatePartialSuccess: 'Batch space creation partially successful',
    invalidRequestParams: 'Request parameter parsing failed',
  },
  plugin: {
    cannotPreview: 'Cannot Preview',
    emptyHintDefault: 'No matching items',
    everyPage: 'Per Page',
    items: 'items',
    total: 'Total',
    clickRefresh: 'Click to Refresh',
  },
  computer: {
    pcName: 'Computer Name',
  },
  loading: 'Loading',
  selectAll: 'Select All',
  nologin: 'Not Logged In',
  edit: 'Edit',
  exportcsv: 'Export CSV',
  createTime: 'Creation Time',
  download: 'Download',
  close: 'Close',
  required: 'Required',
  cancel: 'Cancel',
  delete: 'Delete',
  deleteDirectly: 'Delete Directly',
  actionCanNotRevertConfirm: 'This operation cannot be reverted. Continue?',
  actionDeleteConfirm: 'Confirm deletion?',
  actionRecoveryConfirm: 'Confirm restoration?',
  prompt: 'Prompt',
  confirm: 'Confirm',
  copy: 'Copy',
  copySuccess: 'Copy successful!',
  copyError: 'Copy failed!',
  showMore: 'Show More',
  username: 'Username',
  password: 'Password',
  submit: 'Submit',
  save: 'Save',
  create: 'Create',
  finish: 'Finish',
  operationSuccess: 'Operation successful',
  operationFailed: 'Operation failed',
  operationCancelled: 'Operation cancelled',
  exportLogs:'Export Log',
  notFound: '404 Page Not Found',
  login: 'Login',
  logout: 'Logout',
  yes: 'Yes',
  no: 'No',
  all: 'All',
  refresh: 'Refresh',
  inputRequired: 'This field is required',
  selectRequired: 'This selection is required',
  more: 'More',
  index: 'Index',
  spacename: 'Affiliation',
  updatelog: 'Upload Logs',
  otheroplog: 'Access Logs',
  normal: 'Normal',
  downloadtime: 'Access Time',
  back: 'Back',
  day: 'Day',
  tyrAgain: 'Click to Retry',
  downloadusermanual: 'Download User Manual',
  downwinapp: 'Download Windows Client',
  downandroidapp: "Download Android Client",
  downwinsecagent: 'Download Windows Security Enhancement Agent',
  noData: 'No Data',
  getting: 'Getting...',
  freshPcInfo: 'Refresh Device Information',
  pcInfoRecognize: 'Device Information Recognition:',
  formatError: 'The format you uploaded does not meet the requirements',
  conditionError: 'There is a problem with this filter condition',
  settingError2: 'Filter setting error, please check -2',
  approvalHint: 'Approval requires enabling synchronization (ferry) or inserting Ukey in the client',
  unknownError: 'Unknown Error',
  attention: 'Attention',
  operation: 'Operation',
  search: 'Search',
  reset: 'Reset',
  notAvailableUsingDefault: 'Failed to obtain device information; default values will be used',
  
  // New general internationalization
  warning: 'Warning',
  info: 'Info',
  success: 'Success',

  
  // New member table column titles
  memberAvatar: 'Avatar',
  memberUsername: 'Username',
  memberDepartment: 'Department',
  memberRole: 'Member Role',
  memberSource: 'Source',
  memberCreateTime: 'Creation Time',
  memberOperation: 'Operation',
  memberCurrentUser: 'Current User',
  memberFromDepartment: 'Department',
  memberManualAdd: 'Manual',
  memberTooltipDepartment: 'From Department Binding',
  memberTooltipManual: 'Manual Addition',
  memberEdit: 'Edit',

  // Batch operation buttons
  batchBindMember: 'Bind Members',
  batchSyncMembers: 'Synchronize Members',
  batchSetRole: 'Batch Set Role',
  batchRemoveDepartmentBinding: 'Remove Department Binding',
  
  // Batch add role selection
  setRoleHint: 'Set Role',
  
  // Statistics related
  statisticsMemberStats: 'Member Statistics',
  statisticsTotalMembers: 'Total Members',
  statisticsDepartmentMembers: 'Department Members',
  statisticsManualMembers: 'Manually Added Members',
  statisticsBoundDepartments: 'Bound Departments',
  statisticsDepartmentMemberRatio: 'Department Member Ratio',

  // Fixed text as per Chinese version
  common: {
    search: 'Search',
    reset: 'Reset',
    cancel: 'Cancel',
    confirm: 'Confirm',
    retry:'Retry',
    total:'total',
    startDate:'Start Date',
    endDate:'End Date',
    operationSuccess: 'Operation successful',
    operationFailed: 'Operation failed',
    operationComplete: 'Operation complete',
    syncFailed: 'Synchronization failed',
    unknownError: 'Unknown error',
    all: 'All',
    noError:'No Error',
    unit: 'items',
    delete: 'Delete',
    warning: 'Warning',
    info: 'Info',
    success: 'Success',
    startAdd: 'Start Addition',
    startSync: 'Start Synchronization',
    batchUpdate: 'Batch Update',
    batchAdd: 'Batch Add',
    selectFirst: 'Please select the departments to add first',
    selectDept: 'Select Department',
    sync: 'Synchronize',
    noDeptToAdd: 'No departments need to be added',
    memberRoleReadWrite: 'Read-write',
    willBatchCreateForDepts: 'Will batch create spaces for selected departments',
    batchCreateSuccess: 'Batch creation successful',
    partialSuccess: 'Partial success',
    totalCreated: 'Total spaces created',
    willProcessSelected: 'Will process selected departments',
    bindMember: 'Bind Group Member',
    confirmBatchAddDeptMembers: 'Are you sure you want to batch add department members according to the following configuration?',
    addMode: 'Addition Mode',
    selectedDepts: 'Selected departments',
    subDeptsToAdd: 'Sub-departments',
    totalDeptsToProcess: 'Total departments to process',
    memberRole: 'Member Role',
    processRules: 'Processing Rules',
    addAllUsersInDept: 'Add each department\'s all users',
    skipExistingMembers: 'Skip existing members',
    eachDeptIndependent: 'Each department processed independently, without affecting each other',
    andMoreDepts: '... and other departments',
    unitSpace: 'spaces',
    batchCreateSuccessShort: 'Batch creation successful',
    willBatchCreateSelected: 'Will batch create for selected',
    unknownErrorShort: 'Unknown error',
    batchAddSuccess: 'Batch addition successful',
    batchUpdateSuccess: 'Batch update successful',
    syncSuccess: 'Synchronization successful',
    noMemberAdded: 'Operation completed, but no members were added',
    batchAddFail: 'Batch addition failed'
  },

  // Add independent field before export
  advancedOptions: 'Advanced Options',
  // Removable storage related
  removable: {
    storageManagement: 'Removable Storage Management',
    storageManagementDesc: 'Manage connected removable storage devices (USB drives, external hard drives, etc.)',
    deviceList: 'Device List',
    fileBrowser: 'File Browser',
    operationLogs: 'Operation Logs',
    mountPoint: 'Mount Point',
    playAudio:'Play Audio',
    playVideo:'Play Video',
    operationLogsDesc: 'View operation records of removable storage devices',
    capacity: 'Capacity',
    totalCapacity: "Total Capacity",
    availableSpace: "Available Space",
    onlineDevices: "Online Devices",
    noDeviceFound: 'No removable storage device detected',
    deviceListDesc: 'View and manage all removable storage devices (such as USB drives, external hard drives, etc.)',
    deleteWarning: 'Delete Warning',
    confirmDelete: 'Delete Confirmation',
    deleteDirWarning: 'Directory Delete Warning',
    
    // Device status
    statusConnected: 'Connected',
    statusDisconnected: 'Disconnected',
    statusError: 'Error',
    createDirSuccess: 'Directory created successfully',
    dirNameRequired: 'Please enter directory name',
    
    uploadFailed: "Upload failed",
    noUploadPermission: "No upload permission. Please contact the administrator",
    forbiddenExtension: "File type is not allowed for upload",
    insufficientSpace: "Insufficient storage space",
    // Operation types
    opListDevices: 'List Devices',
    opBrowse: 'Browse Directory',
    opDownload: 'Download File',
    opPreview: 'Preview File',
    opRename: 'Rename',
    opUpload: 'Upload File',
    opDelete: 'Delete File',
    
    opDescListDevices: 'Get list of removable devices',
    opDescBrowse: 'Browse directory contents',
    opDescDownload: 'Download file to local',
    opDescPreview: 'Preview file content',
    opDescRename: 'Rename file/directory',
    opDescUpload: 'Upload file to device',
    opDescDelete: 'Delete file/directory',
    
    // File types
    directory: 'Directory',
    file: 'File',
    enterDirName: 'Enter directory name',
    
    // Operation buttons
    browse: 'Browse',
    upload: 'Upload',
    uploadFolder:'Upload Folder',
    download: 'Download',
    preview: 'Preview',
    rename: 'Rename',
    eject: 'Eject',
    refresh: 'Refresh',
    open: 'Open',
    goBack: 'Go Back',
    backToList: 'Back to List',
    
    // Prompt messages
    searchDevice: 'Search device name',
    searchLogs: 'Search operation logs',
    filterByStatus: 'Filter by status',
    filterByOperation: 'Filter by operation type',
    filterByTime: 'Filter by time',
    selectStatus: 'Select status',
    selectOperation: 'Select operation type',
    deviceNotFound: 'Device not found',
    deviceLoadFailed: 'Device loading failed',
    browseFailed: 'Browse directory failed',
    downloadFailed: 'Download failed',
    previewFailed: 'Preview failed',
    renameFailed: 'Rename failed',

    refreshFailed: 'Refresh failed',
    
    // Confirmation dialogs
    ejectConfirm: 'Confirm Eject Device',
    ejectConfirmDesc: 'Are you sure you want to eject this device? Please ensure all file operations are completed before physically removing the device.',
    renameConfirm: 'Confirm Rename',
    deleteConfirm: 'Confirm Delete',
  
    cannotPreviewDir: 'Cannot preview directory',
    cannotPreviewThisFile: 'This file type is not supported for preview',
    downloadInstead: 'Download instead',
    downloadSelected: 'Download Selected',
    previewSelected: 'Preview Selected',
    
    // New preview related prompts
    cannotPreviewFile: 'This file type does not support preview',
    fileUnaccessible: 'File inaccessible',
    fileType: 'File Type',
    previewSupportedTypes: 'Supported preview file types include:',
    imageTypes: 'Image files (JPG, PNG, GIF, BMP, SVG, etc.)',
    officeTypes: 'Office documents (DOC, DOCX, XLS, XLSX, PPT, PPTX, etc.)',
    pdfType: 'PDF documents',
    textTypes: 'Text files (TXT, MD, JSON, XML, code files, etc.)',
    audioVideoTypes: 'Audio/Video files (MP3, WAV, MP4, AVI, MKV, etc.)',
    
   
    opDescUploadFloader: 'Upload Floader',
    uploadSuccess: 'Upload successful',
    renameSuccess: 'Rename successful',
    deviceRefreshed: 'Device information refreshed',
    uploadFolderSuccess:'Upload Folder Success',
    // Warning messages
    nameNoChange: 'File name not changed',
    cannotDownloadDir: 'Cannot download directory',
    cannotPreview: 'Preview not supported for this file',
    selectFileFirst: 'Please select file first',
    noDeviceSelected: 'No device selected',
    unsupportedPreview: 'Preview not supported for this file type',
    emptyDirectory: 'Directory is empty',
    uploadWarning: 'Upload Warning',
    uploadWarningDesc: 'Please ensure the target device has sufficient storage space and the files do not contain sensitive information.',
    
    // Input prompts
    enterNewName: 'Enter new name',
    enterTargetDir: 'Enter target directory (leave blank for current directory)',
    targetDirHint: 'e.g., /documents or images/photos',
    
    // Statistics
    totalDevices: 'Total Devices',
    connectedDevices: 'Connected Devices',
    totalUsed: 'Total Used Space',
    totalFree: 'Total Free Space',
    totalSize: 'Total Capacity',
    freeSpace: 'Free Space',
    totalFiles: 'Total Files',
    selectedCount: 'Selected {0} items',
    
    // Table columns
    deviceName: 'Device Name',
    fileSystem: 'File System',
    storageInfo: 'Storage Information',
    status: 'Status',
    connectionTime: 'Connection Time',
    operation: 'Operation',
    fileName: 'File Name',
    size: 'Size',
    modifiedTime: 'Modified Time',
    type: 'Type',
    operationTime: 'Operation Time',
    user: 'User',
    device: 'Device',
    filePath: 'File Path',
    errorMessage: 'Error Message',
    
    // Modal titles
    uploadFile: 'Upload File',
    renameFile: 'Rename File',
    selectFile: 'Select File',
    clickToSelectFile: 'Click to select file',
    targetDirectory: 'Target Directory',
    currentDirectory: 'Current Directory',
    rootDirectory: 'Root Directory',
    fileSize: 'File Size',
    renameHint: 'Do not include special characters: \\ / : * ? " < > |',
    selectedFiles: 'Selected Files',

    // Others
    refreshDevices: 'Refresh Devices',
    viewLogs: 'View Logs',
    autoRefreshNotice: 'Auto Refresh Notice',
    autoRefreshNoticeDesc: 'Device list refreshes automatically every 30 seconds',
    fileBrowserDesc: 'Browse files and directories in removable storage devices',
    ejectNotImplemented: 'Device eject function not yet implemented',
    downloadPdf: 'Download PDF',
    pdfPreviewHint: 'PDF files need to be downloaded for viewing',
    startUpload: 'Start Upload',
    uploadToDevice: 'Upload to Device',
    
    // New fields
    filterByFileSystem: 'Filter by file system',
    filterByPlatform: 'Filter by platform',
    selectFileSystem: 'Select file system',
    selectPlatform: 'Select platform',
    showAdvancedFilters: 'Show Advanced Filters',
    hideAdvancedFilters: 'Hide Advanced Filters',
    listView: 'List View',
    gridView: 'Grid View',
  
    refreshSelected: 'Refresh Selected Devices',
    clearSelection: 'Clear Selection',
    batchRefreshSuccess: 'Successfully refreshed {0} devices',
    selectDevicesFirst: 'Please select devices first',
    noDevicesFound: 'No devices found',
    platformDistribution: 'Platform Distribution',
    settings: 'Settings',
    autoRefresh: 'Auto Refresh',
    autoRefreshDesc: 'Auto refresh device list every 30 seconds',
  },
  autoLogin: {
    processing: 'Auto-login in progress...',
    pleaseWait: 'Please wait, processing login request',
    failed: 'Auto-login failed',
    loggingIn: 'Auto-login in progress...'
    },
    device: {
      notSupported: 'Current device does not support terminal feature binding',
      fetchFailed: 'Failed to get device information',
      loading: 'Getting device information...',
      unknown: 'Unknown',
      usingCache: 'Using Cache',
      macAddress: 'MAC Address',
      diskSerial: 'Disk Serial Number',
      deviceName: 'Device Name',
      ipAddress: 'IP Address',
      osInfo: 'Operating System'
    },
  secAgent: {
    installTip: 'Requires installation to bind terminal features or obtain bound intranet IP across three layers!'
    }
};

export default LangEn;